import { Component, computed, ElementRef, inject, input, model, signal, ViewChild } from '@angular/core';
import { NgbDropdownModule, NgbModal, NgbTooltip, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch';
import { SvgIconsComponent } from 'libs/shared/src/lib/components/svg-icons/svg-icons.component';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ProductAttributeService } from '../../services/product-attribute.service';
import { DynamicRouteHandlingService } from 'libs/shared/src/lib/services/dynamic-route-handling.service';
import { NgbModalService } from 'libs/shared/src/lib/services/ngb-modal.service';
import { AttributeValueFormComponent } from '../attribute-value-form/attribute-value-form.component';
import { AttributeValues, ProductAttribute } from '../../models/product.model';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-attribute-card',
  imports: [
    ToggleSwitchModule,
    FormsModule,
    NgbDropdownModule,
    AttributeValueFormComponent,
    SvgIconsComponent,
    NgbTooltip,
    NgbPopover,
    NgClass
  ],
  templateUrl: './attribute-card.component.html',
  styleUrl: './attribute-card.component.scss'
})
export class AttributeCardComponent {
  @ViewChild('addAttributeValue') addAttributeValue!: ElementRef;

  #router = inject(Router);
  #modalService = inject(NgbModal);
  #ngbModalService = inject(NgbModalService);
  #productAttributeService = inject(ProductAttributeService);
  #dynamicRouteHandling = inject(DynamicRouteHandlingService);

  attributeList = input<ProductAttribute>();
  selectedProductListId = input<string | null>(null);
  selectedCategoryId = input<string | null>(null);
  selectedSubcategoryId = input<string | null>(null);
  submitButton = model<boolean>(false);

  toggleAttributeValues = signal<number>(10);
  selectedAttributeValueId = signal<string | null>(null);
  selectedAttributeTypeId = signal<string | null>(null);
  search = signal<string>('');
  attributeValues = computed(() =>
    this.attributeList()?.values.filter((attribute: AttributeValues) =>
      attribute.value.toLowerCase().includes(this.search().toLowerCase())
    )
  );

  deleteAttributeValue() {
    this.#productAttributeService.deleteProductAttributeValue(this.selectedAttributeValueId()!).subscribe(() => {
      this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
    });
    this.selectedAttributeValueId.set(null);
  }

  deleteAttributeType() {
    this.#productAttributeService.deleteProductAttribute(this.selectedAttributeTypeId()!).subscribe(() => {
      this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
    });
    this.selectedAttributeTypeId.set(null);
  }
  openAddAttributeValue() {
    this.#modalService.open(this.addAttributeValue, this.#ngbModalService.centerModal);
  }
  addAttributeType() {
    this.#router.navigate([`/home-building/product-catalogue/attributes/${this.attributeList()?.id}`], {
      queryParamsHandling: 'preserve'
    });
  }
}
